export const SERVER_URL = process.env.REACT_APP_BASE_URL || "http://please-add-server-url.please"

export const FINANCIAL_SERVER_URL =
  process.env.REACT_APP_FINANCIAL_BASE_URL || "http://please-add-finacial-server-url.please"

export const DIGITAL_OCEAN_FILES_ENDPOINT =
  "https://rog-tech.io/files/api/v1/digitalocean/multiFileUpload"
// Http endpoints
export const LOGIN_ENDPOINT = "/auth/login"
export const SIGNUP_ENDPOINT = "/auth/signup"
export const ME_ENDPOINT = "/auth/me"
export const LOGOUT_ENDPOINT = "/auth/logout/"
export const REGISTER_ENDPOINT = "/auth/register/"
export const RESET_PASSWORD_ENDPOINT = "/users/restore_password/change"
export const RESET_PASSWORD_LINK_ENDPOINT = "/users/restore_password/request"
export const GOOGLE_OAUTH_SERVER = "https://xk6s-eqwg-s8by.f2.xano.io/api:U0aE1wpF"
export const GOOGLE_OAUTH_CONTINUE_ENDPOINT = "/oauth/google/continue"
export const GOOGLE_OAUTH_INIT_ENDPOINT = "/oauth/google/init"

// Projects

export const PROJECT_DELETE_ENDPOINT = "/projects/delete"
export const MOVE_TASK_TO_ANOTHER_PROJECT_ENDPOINT = "/tasks/move/toProject"
export const PROJECT_BY_ID_ENDPOINT = `/projects/get/byProjectId`
export const ROLE_SET = "/projects/roles/set"
export const ROLE_EDIT = "/projects/roles/edit"
export const ROLE_DELETE = "/projects/roles/delete"
export const PROJECTS_BY_CURRENT_USER_FILTER = "/projects/get/byCurrentUser/filter"
export const CREATE_PROJECT_ENDPOINT = "/projects/add/byCurrentUser"
export const CREATE_PROJECT_GROUP_ENDPOINT = "/project_group/add"
export const CLONE_PROJECT_ENDPOINT = "/projects/clone"
export const EDIT_PROJECT_BY_CURRENT_USER_ENDPOINT = "/projects/edit/byCurrentUser"
export const PROJECT_MEMBERS_REMOVE = "/projects/members/remove"
export const PIN_PROJECT_ENDPOINT = "/projects/pin"
export const PROJECT_REMINDER_SET_ENDPOINT = "/projects/reminder/set"
export const PROJECT_MAP_ADD_ANNOTATIONS_ENDPOINT = "/projects/map/addAnnotation"
export const PROJECT_MAP_EDIT_ANNOTATIONS_ENDPOINT = "/projects/map/editAnnotation"
export const PROJECT_MAP_DELETE_ANNOTATIONS_ENDPOINT = "/projects/map/deleteAnnotation"

// Work diary
export const GET_WORK_DIARY_BY_PROJECT = "/diary/get/ByProject"
export const WORK_DIARY_DELETE_ENDPOINT = "/diary/delete"
export const WORK_DIARY_RESTORE_ENDPOINT = "/diary/restore"
export const WORK_DIARY_ADD_ENDPOINT = "/diary/create"
export const WORK_DIARY_EDIT_ENDPOINT = "/diary/edit"
export const DICTIONARY_RESOURCES_ADD_ENDPOINT = "/diary/dictionary/resources/add"
export const DICTIONARY_RESOURCES_EDIT_ENDPOINT = "/diary/dictionary/resources/edit"
export const GET_DICTIONARY_RESOURCES_ENDPOINT = "/diary/dictionary/resources"
export const WORK_DIARY_RESOURCES_ADD_ENDPOINT = "/diary/resources/add"
export const WORK_DIARY_RESOURCES_EDIT_ENDPOINT = "/diary/resources/edit"
export const WORK_DIARY_RESOURCES_DELETE_ENDPOINT = "/diary/resources/delete"
export const GET_WEATHER = "/diary/dictionary/weather"
export const GET_STATUS = "/diary/dictionary/status"
export const GET_CONTRACTOR = "/diary/contractors/get"
export const CONTRACTOR_APPROVAL_ENDPOINT = "/diary/approval/contractor/set"
export const SUPERVISOR_APPROVAL_ENDPOINT = "/diary/approval/supervisor/set"
export const WORK_DIARY_GET_NOTE_BY_ID = "/notes/get/byDiaryId"
export const WORK_DIARY_GET_BY_ID = "/diary/get/byId/"
export const GET_WORK_DIARY_STATUS = "/diary/dictionary/status"
export const WORK_DIARY_FILES_ADD_ENDPOINT = "/diary/files/add"
export const WORK_DIARY_CLONE_ENDPOINT = "/diary/clone"

// Notes
export const NOTES_ADD_ENDPOINT = "/notes/add"
export const NOTES_LIST_ENDPOINT = "/notes/get"
export const GET_FILTERS_BY_PROJECT = "/diary/get/filters/ByProject"

// TASKS
export const TASK_DELETE_ENDPOINT = "/tasks/delete"
export const TASK_SESSION_ADD_ENDPOINT = "/tasks/session/add"
export const TASK_SESSION_FINISH_ENDPOINT = "/tasks/session/finish"
export const TASK_SESSION_DELETE_ENDPOINT = "/tasks/session/delete"
export const TASK_SESSION_GET_ACTIVE = "/tasks/session/get_active"
export const EDIT_TASK_ENDPOINT = "/tasks/edit/byCurrentUser"
export const CREATE_TASK_ENDPOINT = "/tasks/add/byCurrentUser"
export const ADD_TASK_DEPENDENCY_ENDPOINT = "/tasks/dependency/add"
export const REMOVE_TASKS_DEPENDENCY_ENDPOINT = `/tasks/dependency/remove`
export const TASK_BY_ID_ENDPOINT = "/tasks/get/byTaskId/"
export const TASK_BY_CURRENT_USER_ENDPOINT = "/tasks/get/byCurrentUser/filter"
export const CONVERT_SUB_TASK_TO_TASK_ENDPOINT = "/tasks/subtasks/turnIntoTask"
export const PIN_TASK_ENDPOINT = "/tasks/pin"
export const TASK_GIS_ENDPOINT = "/tasks/gis/add"
export const PROJECTS_WISE_TASK_LIST = "/projects/get/byTaskAssigment"
export const TASKS_PROJECT_WISE = "/tasks/get/byAssigment/byProject"
//TASK-GROUP
export const TASK_GROUP_ADD = "/tasks_group/add/byCurrentUser"
export const EDIT_TASK_GROUP = "/tasks_group/edit"
export const RESTORE_TASK_GROUP = "/tasks_group/restore"
export const TASK_GROUP_DELETE = "/tasks_group/delete/"
export const TASK_MOVE_TO_GROUP = "/tasks/move/toGroup"
export const GET_TASK_GROUPS = "/tasks/get/byCurrentUser/byProject"
export const GET_SUB_TASKS = "/tasks/get/subtasks/byTask"
export const EXPORT_ALL_TASKS = "/tasks/export/byCurrentUser/byProject"

// notes
export const UNLIKE_NOTE_ENDPOINT = "/notes/unlike"
export const NOTES_BY_CURRENT_USER_ENDPOINT = "/notes/get/byCurrentUser"
export const NOTES_BY_TASK_ID_ENDPOINT = "/notes/get/byTaskId/"
export const UPDATE_NOTE_ENDPOINT = "/notes/edit"
export const DELETE_NOTE_ENDPOINT = "/notes/delete"
export const LIKE_NOTE_ENDPOINT = "/notes/like"
export const VIEW_NOTE_ENDPOINT = "/notes/viewed/byUser"

// users
export const USERS_BY_ID_ENDPOINT = "/users/get/byId"
export const ORG_USERS_ENDPOINT = "/users/get/byId"

// Invitations
export const INVITE_USERS_ENDPOINT = "/invitation/generate/byCurrentUser"
export const NEW_USERS_INVITATION_ENDPOINT = "/invitation/new_user"
export const VALIDATE_INVITE_ENDPOINT = "/invitation/validate_user"
export const ACCEPT_INVITE_ENDPOINT = "/invitation/accept"

// Files
export const FOLDER_ENDPOINT = "/folders-wp/get/"
export const FOLDER_RENAME_ENDPOINT = "/folders/rename"
export const ADD_FILE_ENDPOINT = "/files/add"
export const DELETE_FOLDER_ENDPOINT = "/folders/delete"
export const RESTORE_FOLDER_ENDPOINT = "/folders/restore"
export const DELETE_FILE_ENDPOINT = "/files/delete"
export const DELETE_MULTIPLE_FILE_ENDPOINT = "/files/delete_batch"
export const RESTORE_FILE_ENDPOINT = "/files/restore"
export const MOVE_FILE_ENDPOINT = "/files/moveToFolder"
export const ADD_FILES_TO_PROJECT_ENDPOINT = "/files/addToProject"
export const ADD_FILES_TO_TASK_ENDPOINT = "/files/addToTask"
export const ADD_FILES_TO_NOTE_ENDPOINT = "/files/addToNote"
export const GET_FILES_ENDPOINT = "/files/get/"
export const CREATE_FOLDER = "/folders/add"
export const GET_FOLDER_AND_FILE_V2= "/folders-wp/v2/get/"

// MAPBOX
export const MAPBOX_PLACES_ENDPOINT = "https://api.mapbox.com/geocoding/v5/mapbox.places/"

// Dictionaries

export const PROJECT_TYPES_DICTIONARY_ENDPOINT = "/dictionary/project_type"
export const NEIGHBORHOOD_DICTIONARY_ENDPOINT = "/dictionary/water/neighborhood"
export const STATUS_DICTIONARY_ENDPOINT = "/dictionary/statuses"
export const PRIORITY_DICTIONARY_ENDPOINT = "/dictionary/priority"
export const DEPARTMENTS_DICTIONARY_ENDPOINT = "/dictionary/department"
export const USER_ROLE_DICTIONARY_ENDPOINT = "/dictionary/user_role"
export const JOB_TITLE_DICTIONARY_ENDPOINT = "/dictionary/job_title"
export const USER_STATUS_DICTIONARY_ENDPOINT = "/dictionary/user_status"
export const STATISTICS_PERIOD_DICTIONARY_ENDPOINT = "/dictionary/statistics_periods"
export const PROJECT_WORK_TYPES_DICTIONARY_ENDPOINT = "/dictionary/work_type"
export const DELETE_ROLE_DICTIONARY_ENDPOINT = "/dictionary/user_role/delete"

export const ADD_DEPARTMENT_ENDPOINT = "/dictionary/department/add"
export const ADD_JOB_TITLE_ENDPOINT = "/dictionary/job_title/add"
export const ADD_USER_ROLE_ENDPOINT = "/dictionary/user_role/add"

// Custom
export const ADD_CUSTOM_COLUMNS_ENDPOINT = "/customize/columns/add"
export const DELETE_CUSTOM_COLUMNS_ENDPOINT = "/customize/column/delete"

// Project Custom Columns
export const ADD_PROJECT_CUSTOM_COLUMNS_ENDPOINT = "/customize/project/columns/add"
export const DELETE_PROJECT_CUSTOM_COLUMNS_ENDPOINT = "/customize/project/column/delete"
export const GET_PROJECT_CUSTOM_COLUMNS_ENDPOINT = "/customize/project/get"

// Statistics
export const TASKS_STATISTICS_BY_PERIOD_ENDPOINT = "/statistics/tasks/byPeriod"
export const TASKS_STATISTICS_ENDPOINT = "/statistics/getTasks"
export const PROJECTS_STATISTICS_BY_PERIOD_ENDPOINT = "/statistics/projects/byPeriod"
export const PROJECTS_STATISTICS_ENDPOINT = "/statistics/getProjects"
export const USED_SPACE_STATISTICS_ENDPOINT = "/statistics/usedSpace"
export const GET_STATISTICS_TASKS_CHART_ENDPOINT = "/statistics/tasksChart"

// Users
export const USER_ENDPOINT = "/accounts/users"
export const ALL_ORG_USERS_ENDPOINT = "/organization/users/getAll"
export const ADD_PROFILE_PICTURE_ENDPOINT = "/files/addProfilePicture"
export const USER_ORGANIZATION_UPDATE_ENDPOINT = "/users/last_organization/set"
export const ORGANIZATION_UPDATE_NAME_ENDPOINT = "/organization/setCompanyName"
export const ORGANIZATION_UPDATE_LOGO_ENDPOINT = "/organization/setLogo"
export const ORGANIZATION_REMOVE_USER_ENDPOINT = "/organization/removeUser"
export const ORGANIZATION_LANGUAGE_ENDPOINT = "/organization/setLanguage"
export const ORGANIZATION_SET_TIMEZONE_ENDPOINT = "/organization/setTimeZone"
export const USER_LANGUAGE_ENDPOINT = "/users/language/set"
export const USER_ROLE_TRANSFER_ENDPOINT = "/users/accesses_transfer_v2"

export const EDIT_USER_ENDPOINT = "/users/edit/personal/byCurrentUser"
export const EDIT_USER_ORG_PARAMETER_ENDPOINT = "/users/edit/organizationParameters"

// Team
export const USER_TEAMS_ENDPOINT = "/teams/getAll/byCurrentUser"

// Settings
export const GET_WMS_ENDPOINT = "/settings/wms/get"
export const ADD_WMS_ENDPOINT = "/settings/wms/add"
export const UPDATE_WMS_ENDPOINT = "/settings/wms/update"
export const DELETE_WMS_ENDPOINT = "/settings/wms/delete"
export const COMPANY_SETTINGS_ENDPOINT = "/settings/get/company_access"
export const COMPANY_SETTINGS_SET_ENDPOINT = "/settings/set/company_access"
export const COMPANY_PRINT_GET_ENDPOINT = "/settings/print/get"
export const COMPANY_PRINT_ADD_ENDPOINT = "/settings/print/add"
export const COMPANY_PRINT_UPDATE_ENDPOINT = "/settings/print/update"
export const COMPANY_PRINT_DELETE_ENDPOINT = "/settings/print/delete"

export const GET_ALL_FOLDERS_ENDPOINT = "/folders-wp/getAll/byCurrentUser"

// ORGANIZATION
export const GET_ORGANIZATION = "/organization/get"

// Google Recaptcha
export const RECAPTCHA_ENDPOINT = "https://www.google.com/recaptcha/api.js"

// LOGS
export const LOGS_BY_PROJECT_ID_ENDPOINT = "/logs/project"
export const LOGS_BY_TASK_ID_ENDPOINT = "/logs/task"

// FINANCIAL
export const BILL_CREATE_ENDPOINT = "/bill/new/byItems"
export const SIGNED_BILLS_BY_BOQ_ID_ENDPOINT = "/bill/signed/byBoqId"
export const UNSIGNED_BILLS_BY_BOQ_ID_ENDPOINT = "/bill/for_sign/byBoqId"
export const BILLS_BY_BOQ_ID_ENDPOINT = "/bill/byBoqId"
export const BILLS_BY_BOQ_ID__LIST_ENDPOINT = "/bill/byBoqId/list"
export const BILL_CREATE__BY_UPLOAD_ENDPOINT = "/bill/new/upload"
export const BILL_APPROVE_ENDPOINT = "/bill/approve"
export const BILL_DECLINE_ENDPOINT = "/bill/decline"
export const BILL_DECLINE_BY_SIGNER = "/bill/decline_by_signer"
export const CONTRACTOR_COMPANY_ALL_ENDPOINT = "/company/get/all"
export const CONTRACTOR_COMPANY_ADD_ENDPOINT = "/company/add"
export const CONTRACTOR_COMPANY_BY_ID_ENDPOINT = "/company/get/byID/"
export const CONTRACTOR_COMPANY_EDIT_ENDPOINT = "/company/edit"
export const PRICE_LIST_ALL_ENDPOINT = "/priceList/get/all"
export const PRICE_LIST_BY_ID_ENDPOINT = "/priceList/get/byId/"
export const PRICE_LIST_ADD_ENDPOINT = "/priceList/new"
export const PRICE_LIST_EDIT_ENDPOINT = "/priceList/edit"
export const PRICE_LIST_DELETE_ENDPOINT = "/priceList/delete"
export const PRICE_LIST_ITEM_DELETE_ENDPOINT = "/priceList/item/delete"
export const ADD_FINANCIAL_PROJECT_ROLE_ENDPOINT = "/project_role/add"
export const GET_FINANCIAL_PROJECT_ROLE_ENDPOINT = "/project_role/byProject"
export const ANALYTICS_TASKS_SUMMARY_ENDPOINT = "/analytics/tasks/summary"
export const ANALYTICS_DIARIES_SUMMARY_ENDPOINT = "/analytics/diaries/summary"
export const SUMMARY_PROJECTS_ENDPOINT = "/summary/projects"
export const ORGANIZATION_PROJECT_ROLES_ENDPOINT = "/project_role/types/getAll"
export const DELETE_ORGANIZATION_PROJECT_ROLES_ENDPOINT = "/project_role/delete/project_role"
export const SET_USER_PROJECT_ROLE_ENDPOINT = "/project_role/set"
export const DELETE_PROJECT_USER_ROLE_ENDPOINT = "/project_role/delete/user_role"
export const ORGANIZATION_SIGNATURE_SETTINGS_ENDPOINT = "/signature/organization/get"
export const SET_ORGANIZATION_SIGNATURE_ENDPOINT = "/signature/organization/settings"
export const SET_PROJECT_SIGNATURE_ENDPOINT = "/signature/project/settings"
export const GET_SIGNATURE_RIGHTS_ENDPOINT = "/signature/rights/get"
export const SET_SIGNATURE_RIGHTS_ENDPOINT = "/signature/rights/set"
export const ESTIMATE_BOQ_ENDPOINT = "/boq_estimate/new"
export const ALL_ESTIMATE_BOQ_ENDPOINT = "/boq_estimate/get/all"
export const GET_ESTIMATE_BOQ_ENDPOINT = "/boq_estimate/get/byId"
export const DELETE_ESTIMATE_BOQ_ENDPOINT = "/boq_estimate"
export const RESTORE_ESTIMATE_BOQ_ENDPOINT = "/boq_estimate/restore"
export const MAIN_BOQ_ENDPOINT = "/boq_main/new"
export const MAIN_BOQ_BULK_ENDPOINT = "/boq_main/new/bulk"
export const ALL_MAIN_BOQ_ENDPOINT = "/boq_main/get/all"
export const RESTORE_MAIN_BOQ_ENDPOINT = "/boq_main/restore"
export const GET_MAIN_BOQ_ENDPOINT = "/boq_main/get/byId"
export const GET_MAIN_BOQ_SECTIONS_ENDPOINT = "/boq_main/sections/all/get"
export const GET_MAIN_BOQ_ITEMS_BY_SECTION_ID_ENDPOINT = "/boq_main/items/by_sections_id" //Integrate
export const GET_MAIN_BOQ_ITEMS_BY_SECTION_NUMBER_ENDPOINT = "/boq_main/items/by_sections_number" //Integrate
export const DELETE_MAIN_BOQ_ENDPOINT = "/boq_main"
export const APPROVE_INITIAL_PRICE_BOQ_ENDPOINT = "/boq_initial/price/approve"
export const APPROVE_ALL_INITIAL_BOQ_ENDPOINT = "/boq_initial/price/approve_all"
export const REQUEST_AMOUNT_APPROVE_BOQ_ENDPOINT = "/boq_request/amount/approve"
export const REQUEST_AMOUNT_DECLINE_BOQ_ENDPOINT = "/boq_request/amount/decline"
export const REQUEST_AMOUNT_BOQ_ENDPOINT = "/boq_request/amount/request"
export const REQUEST_AMOUNT_BY_ITEM_BOQ_ENDPOINT = "/boq_request/amount/request/byItem" //Integrate
export const REQUEST_FOR_APPROVING_BY_BOQ_ID_ENDPOINT = "/boq_request/request/for_approving/byBoqId"
export const REQUEST_ADD_NEW_BOQ_ITEM_ENDPOINT = "/boq_request/new_item/add"
export const REQUEST_FOR_SIGNING_BOQ_ID_ENDPOINT = "/boq_request/request/for_sign/byBoqId"
export const REQUEST_SIGNING_ENDPOINT = "/boq_request/signing"
export const EDIT_BILL_ENDPOINT = "/bill/new/edit"
export const SET_BILL_VAT_ENDPOINT = "/bill/set/vat"
export const RETURN_BILL_ENDPOINT = "/bill/return"
export const SIGN_BILL_ENDPOINT = "/bill/signing"
export const DELETE_BILL_ENDPOINT = "/bill/delete"
export const LAST_SIGNATURE_ENDPOINT = "/signature/get/last_signature"
export const SET_TOUR_VIEW = "/users/set/tour_is_viewed"

export const GLOBAL_SEARCH_ENDPOINT = "/search"
export const CREATE_PROJECT_GROUP = "/project_group/add"
export const UPDATE_PROJECT_GROUP = "/project_group/edit"
export const DELETE_PROJECT_GROUP = "/project_group/delete"
export const MAPPING_ADD_ENDPOINT = "/mapping/add"
export const MAPPING_GET_ENDPOINT = "/mapping/get"

export const GET_LATEST_FILES = "/files/getAll/byCurrentUser"
export const GET_ACTIVITIES_LIST = "/activites/get/byUser"
export const FILES_SHARE = "/files/share"
export const PROJECTS_GET_BY_CURRENT_USER_BY_GROUP = "/projects/get/byCurrentUser/byGroup"
export const GET_NOTIFICATIONS = "/messages_new/get/byCurrentUser2"
export const GET_NOTIFICATION_UNREAD_COUNT = "/messages_new/get/unreadCount"
export const GET_UPDATE_LOGS = "/messages_new/get_logs/byCurrentUser"
export const TASK_GROUP_CLONE = "/tasks_group/clone"
export const CREATE_TASK_CLONE = "/tasks/clone"
export const ACTIVITIES_LIKE = "/activites/like"
export const ACTIVITIES_UNLIKE = "/activites/unlike"
export const DELETE_MULTIPLE_TASK = "/tasks/delete_bulk"
export const GET_KANBAN_TASKS_ALL = "/kanban/tasks/all"
export const GET_KANBAN_STATUS_WISE_TASKS = "/kanban/tasks/byStatus"
export const GET_USER_KANBAN_TASK_COLUMN_ORDER = "/users/get/visual_settings"
export const SET_USER_KANBAN_TASK_COLUMN_ORDER = "/users/set/visual_settings"
export const CREATE_MULTIPLE_TASK_CLONE = "/tasks/clone_bulk"
export const PIN_MY_PROJECTS = "/projects/byUser/pin"
export const PIN_MY_TASKS = "/tasks/byUser/pin"
export const PROJECT_ROLE_BY_USER = "/project_role/byUser"
export const BILL_DIARY_LINK = "/bill/diary/link"
export const BOQ_REQUEST_NEW_ITEM_APPROVE = '/boq_request/new_item/approve'
export const BOQ_REQUEST_NEW_ITEM_DELETE = '/boq_request/new_item/delete'
export const BOQ_REQUEST_NEW_ITEM_EDIT = '/boq_request/new_item/edit'
export const PROJECT_RESTORE = "/projects/restore"
export const RESTORE_TASK = "/tasks/restore"
export const RESTORE_BILL = "/bill/restore"
export const TASKS_IMPORT_TO_PROJECT = "/tasks/import/toProject"
export const CREATE_CONTRACTOR_COMPANY = "/contractor_company/add"
export const GET_CONTRACTOR_COMPANY_LIST="/contractor_company/get/all"
export const EDIT_CONTRACTOR_COMPANY = "/contractor_company/edit"
export const ADD_CONTRACTOR_COMPANY_USERS = "/contractor_company/users/add"
export const REMOVE_CONTRACTOR_COMPANY_USERS = "/contractor_company/users/remove"
export const DELETE_CONTRACTOR_COMPANY = "/contractor_company/delete"
export const SET_CONTRACTOR_COMPANY_PROJECT_ROLE = "/project_role/contracor_company/set"
export const NEW_GET_ALL_FOLDERS_ENDPOINT = "/folders-wp/getAll/byCurrentUser1"
export const GET_USERS_ACCESSES_ENDPOINT = "/users/accesses_v2"
export const GET_PROJECT_GROUP_ENDPOINT = "/project_group/get/groupTree/byOrganization"

